function e(n, t, c) {
  const r = n[t];
  if (r !== void 0) return r;
  const u = c();
  return n[t] = u, u;
}
export {
  e as u
};
